import { useGlobalStore } from "@/GlobalStore";
import { StreamState } from "@/services/backgroundStreamManager";

/**
 * Hook that subscribes to global stream changes using Zustand store
 */
export function useGlobalStreams() {
  const activeStreams = useGlobalStore((state) => state.activeStreams);
  const getStreamById = useGlobalStore((state) => state.getStreamById);
  const getStreamsByAccount = useGlobalStore((state) => state.getStreamsByAccount);
  const getStreamsByReport = useGlobalStore((state) => state.getStreamsByReport);
  const getStreamByChatId = useGlobalStore((state) => state.getStreamByChatId);

  // Convert Map to array
  const streams: StreamState[] = Array.from(activeStreams.values());

  return {
    streams,
    getStream: getStreamById,
    getStreamsByAccount,
    getStreamsByReport,
    findByChatId: (chatId: string) => getStreamByChatId(chatId),
  };
}
